export default function ChatBotIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.07715 16.3532L0.667978 17.3332L1.64798 12.924C1.00259 11.7168 0.665917 10.3687 0.667978 8.99984C0.667978 4.39734 4.39881 0.666504 9.00131 0.666504C13.6038 0.666504 17.3346 4.39734 17.3346 8.99984C17.3346 13.6023 13.6038 17.3332 9.00131 17.3332C7.63244 17.3352 6.28433 16.9986 5.07715 16.3532ZM5.31881 14.5923L5.86298 14.884C6.82844 15.4 7.90664 15.6688 9.00131 15.6665C10.3199 15.6665 11.6088 15.2755 12.7051 14.543C13.8014 13.8104 14.6559 12.7692 15.1605 11.5511C15.6651 10.3329 15.7971 8.99244 15.5399 7.69924C15.2826 6.40603 14.6477 5.21814 13.7154 4.28579C12.783 3.35344 11.5951 2.7185 10.3019 2.46127C9.00871 2.20403 7.66826 2.33606 6.45009 2.84064C5.23191 3.34522 4.19072 4.19971 3.45818 5.29604C2.72564 6.39236 2.33464 7.6813 2.33464 8.99984C2.33464 10.1115 2.60548 11.1815 3.11798 12.1382L3.40881 12.6823L2.86298 15.1382L5.31881 14.5923ZM4.83465 8.99984H6.50131C6.50131 9.66288 6.7647 10.2988 7.23354 10.7676C7.70239 11.2364 8.33827 11.4998 9.00131 11.4998C9.66435 11.4998 10.3002 11.2364 10.7691 10.7676C11.2379 10.2988 11.5013 9.66288 11.5013 8.99984H13.168C13.168 10.1049 12.729 11.1647 11.9476 11.9461C11.1662 12.7275 10.1064 13.1665 9.00131 13.1665C7.89624 13.1665 6.83644 12.7275 6.05503 11.9461C5.27363 11.1647 4.83465 10.1049 4.83465 8.99984Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
